import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MobileConfigService } from '../services/mobile/mobile-config.service';

/**
 * Guard that restricts access to mobile-only routes
 * Redirects to home page if accessed from web browser
 * 
 * @example
 * ```typescript
 * {
 *   path: 'rfid-power',
 *   component: RfidPowerManagementComponent,
 *   canActivate: [authGuard, mobileOnlyGuard]
 * }
 * ```
 */
export const mobileOnlyGuard: CanActivateFn = (route, state) => {
  const mobileConfig = inject(MobileConfigService);
  const router = inject(Router);

  // Check if running on mobile platform
  if (mobileConfig.isMobile()) {
    return true;
  }

  // Redirect to home if not on mobile
  return router.createUrlTree(['/home']);
};
